import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import TrainingHistoryModal from '@/components/container/modal/trainingHistory/TrainingHistoryModal'

interface TrainingHistoryModalState {
  siteId: number
}

const defaultValue: TrainingHistoryModalState = { siteId: 0 }

export const TrainingHistoryModalContext =
  createModalContext<TrainingHistoryModalState>(defaultValue)

const TrainingHistoryModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<TrainingHistoryModalState>(defaultValue)
  return (
    <TrainingHistoryModalContext.Provider value={state}>
      {children}
      <TrainingHistoryModal />
    </TrainingHistoryModalContext.Provider>
  )
}

export default TrainingHistoryModalProvider
